import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const Fresherjobs = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Fresher Jobs in Delhi | Latest Job Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest fresher jobs in Delhi NCR for graduates and students. Apply for IT, Marketing, Finance, HR, and Sales jobs in top companies hiring freshers in Delhi."
        />
        <meta
          name="keywords"
          content="fresher jobs in Delhi, fresher jobs in Delhi NCR, jobs for freshers in Delhi, IT fresher jobs Delhi, marketing fresher jobs Delhi, graduate jobs Delhi, entry-level jobs Delhi"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://jobsindelhincr.in/fresher-jobs-in-delhi" />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Fresher Jobs in Delhi – Latest Job Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for the latest <strong>fresher jobs in Delhi</strong>? Explore
          thousands of opportunities in IT, Marketing, Finance, Education,
          Healthcare, and more. Whether you’re a graduate or a student, find your
          first job in Delhi NCR today and kickstart your career.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Freshers in Delhi
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Infosys</li>
          <li>Wipro</li>
          <li>Tech Mahindra</li>
          <li>HCL</li>
          <li>Accenture</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Job Categories Available
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Software Development Jobs in Delhi</li>
          <li>Marketing Jobs in Delhi</li>
          <li>Finance Jobs in Delhi</li>
          <li>Sales Jobs in Delhi</li>
          <li>Full-time Jobs in Delhi</li>
          <li>Web Development Jobs in Delhi</li>
          <li>Digital Marketing Jobs in Delhi</li>
          <li>Telecalling Jobs in Delhi</li>
          <li>IT Jobs in Delhi</li>
          <li>Technical Support Jobs in Delhi</li>
          <li>App Development Jobs in Delhi</li>
          <li>HR Jobs in Delhi</li>
          <li>Fresher Jobs in Delhi</li>
          <li>Frontend Developer Jobs in Delhi</li>
          <li>Backend Developer Jobs in Delhi</li>
          <li>Full Stack Developer Jobs in Delhi</li>
        </ul>

        <p className="text-gray-600">
          Start your career with <strong>JobsInDelhiNCR.in</strong> – your trusted
          platform to find verified <strong>fresher job openings</strong> in Delhi NCR.
          No registration required – apply directly to companies hiring today!
        </p>
      </div>

      <Footer />
    </>
  );
};

export default Fresherjobs;
